export default timestring => {
  const parts = timestring.split('/');
  const date = new Date(parts[2], parts[1] - 1, parts[0], 12, 0, 0, 0);
  const unix = date.getTime() / 1000;
  return unix;
};
